import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

export default function Title(prop) {
  return (
    <View style={styles.header}>
      <Text style={styles.title}>{prop.text}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    width: "100%",
    alignItems: 'center',
  },
  title: {
    size: 20,
    fontWeight: "bold",
    textTransform: "uppercase"
  }
});
